import React from 'react'

import AddProductForm from '../../AddProductForm'
import { useOrderItems } from '../contexts/OrderItemsContext'
import { ModalOverlay, ModalWrapper } from '../style'

const FashionProductModal: React.FC = () => {
  const {
    addedProducts, setAddedProducts, productToEdit, editingProductIndex,
    showAddProductForSection, setIsKitMode,
    closeProductEdit, handleRemoveProduct, handleProductUpdated, handleNewProductAdded,
  } = useOrderItems()

  if (showAddProductForSection === null) return null

  return (
    <ModalOverlay onClick={closeProductEdit}>
      <ModalWrapper onClick={(e) => e.stopPropagation()}>
        <AddProductForm
          order={addedProducts}
          setOrder={setAddedProducts}
          product={productToEdit}
          isEditing={editingProductIndex !== null}
          onProductAdded={editingProductIndex === null ? handleNewProductAdded : undefined}
          onProductUpdated={editingProductIndex !== null ? handleProductUpdated : undefined}
          onRemoveProduct={handleRemoveProduct}
          onClose={closeProductEdit}
          isKitMode={showAddProductForSection !== 'standalone'}
          setIsKitMode={setIsKitMode}
        />
      </ModalWrapper>
    </ModalOverlay>
  )
}

export default FashionProductModal
